/*
 * ET Cart Page — reviews slider (EcomTraffic · Finex)
 * Swiper 11 (global `Swiper`, assets/et-swiper-bundle.min.js) for sections/et-cart-page-reviews.liquid.
 * Markup: [data-et-cart-reviews] > [data-et-cart-reviews-swiper] + [data-et-cart-reviews-prev] / [data-et-cart-reviews-next]
 * A slider is only initialised while visible (cards can be hidden per breakpoint, the sidebar is hidden on an
 * empty cart). Re-initialised on DOMContentLoaded, shopify:section:load and et-cart:section-replaced; a
 * ResizeObserver, the 750px breakpoint change and a post-replace frame initialise sliders that became visible
 * and destroy sliders that became hidden.
 */
(function () {
  'use strict';

  const ROOT_SELECTOR = '[data-et-cart-reviews]';
  const SWIPER_SELECTOR = '[data-et-cart-reviews-swiper]';
  const SLIDE_SELECTOR = '[data-et-cart-reviews-slide]';
  const MOBILE_QUERY = typeof window.matchMedia === 'function' ? window.matchMedia('(max-width: 749px)') : null;

  function rootsIn(scope) {
    if (scope !== document && !(scope instanceof Element)) return [];
    const roots = Array.from(scope.querySelectorAll(ROOT_SELECTOR));
    if (scope instanceof Element && scope.matches(ROOT_SELECTOR)) roots.unshift(scope);
    return roots;
  }

  const swiperElOf = (root) => root.querySelector(SWIPER_SELECTOR);
  const isVisible = (element) => element.getClientRects().length > 0;

  function destroy(root) {
    const swiperEl = swiperElOf(root);
    if (swiperEl && swiperEl.swiper) swiperEl.swiper.destroy(true, true);
  }

  function init(root) {
    destroy(root);

    const swiperEl = swiperElOf(root);
    if (!swiperEl || typeof window.Swiper !== 'function' || !isVisible(swiperEl)) return;

    const prevEl = root.querySelector('[data-et-cart-reviews-prev]');
    const nextEl = root.querySelector('[data-et-cart-reviews-next]');
    const a11y = { enabled: true };
    if (prevEl && prevEl.getAttribute('aria-label')) a11y.prevSlideMessage = prevEl.getAttribute('aria-label');
    if (nextEl && nextEl.getAttribute('aria-label')) a11y.nextSlideMessage = nextEl.getAttribute('aria-label');

    // eslint-disable-next-line no-new
    new window.Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 16,
      watchOverflow: true,
      speed: 400,
      navigation: prevEl && nextEl ? { prevEl, nextEl } : false,
      a11y
    });
  }

  /** Breakpoint change: only touch sliders whose visibility changed, so the current slide is kept. */
  function sync(root) {
    const swiperEl = swiperElOf(root);
    if (!swiperEl) return;
    const visible = isVisible(swiperEl);
    if (visible && !swiperEl.swiper) init(root);
    else if (!visible && swiperEl.swiper) destroy(root);
  }

  /*
   * Visibility watcher: a slider can become visible without a breakpoint change or section event
   * (e.g. the cart sidebar is display:none on an empty cart and is revealed after an AJAX add).
   * A hidden element has a 0×0 box, so ResizeObserver fires when it is revealed or hidden again.
   */
  const resizeObserver =
    typeof window.ResizeObserver === 'function'
      ? new window.ResizeObserver((entries) => {
          entries.forEach((entry) => {
            const root = entry.target.closest(ROOT_SELECTOR);
            if (root) sync(root);
          });
        })
      : null;

  function observe(root) {
    const swiperEl = swiperElOf(root);
    if (resizeObserver && swiperEl) resizeObserver.observe(swiperEl);
  }

  function unobserve(root) {
    const swiperEl = swiperElOf(root);
    if (resizeObserver && swiperEl) resizeObserver.unobserve(swiperEl);
  }

  const initIn = (scope) =>
    rootsIn(scope).forEach((root) => {
      init(root);
      observe(root);
    });

  const destroyIn = (scope) =>
    rootsIn(scope).forEach((root) => {
      unobserve(root);
      destroy(root);
    });

  const syncAll = () => rootsIn(document).forEach(sync);

  function onBlockSelect(event) {
    const slide = event.target instanceof Element ? event.target.closest(SLIDE_SELECTOR) : null;
    const root = slide && slide.closest(ROOT_SELECTOR);
    const swiperEl = root && swiperElOf(root);
    if (!swiperEl || !swiperEl.swiper) return;

    const index = Array.prototype.indexOf.call(swiperEl.querySelectorAll(SLIDE_SELECTOR), slide);
    if (index > -1) swiperEl.swiper.slideTo(index, 0);
  }

  const onReady = () => initIn(document);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onReady);
  else onReady();

  document.addEventListener('shopify:section:load', (event) => initIn(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroyIn(event.target));
  document.addEventListener('shopify:block:select', onBlockSelect);
  document.addEventListener('et-cart:section-replaced', (event) => {
    if (event.detail && event.detail.element) initIn(event.detail.element);
    // The controller toggles .et-cart-page--empty (sidebar visibility) right after this event: re-check next frame
    // (fallback for browsers without ResizeObserver).
    window.requestAnimationFrame(syncAll);
  });

  if (MOBILE_QUERY) {
    if (typeof MOBILE_QUERY.addEventListener === 'function') MOBILE_QUERY.addEventListener('change', syncAll);
    else if (typeof MOBILE_QUERY.addListener === 'function') MOBILE_QUERY.addListener(syncAll);
  }
})();
